import React, { createContext, useState, useEffect, useContext } from 'react';
import commonApi from '../utils/api';
import { CommonContext } from './CommonContext';
import moment from 'moment/moment';
import { useNavigate } from 'react-router-dom';

export const DashboardB2BContext = createContext();

export function DashboardB2BContextProvider({ children }) {
    const { user } = useContext(CommonContext);
    const [addModal, setAddModal] = useState(false);
    const [allPandingSummary, setAllPandingSummary] = useState([]);
    const [allData, setAllData] = useState({});
    const [allPickupPandingSummary, setAllPickupPandingSummary] = useState({});

    const [allDownload, setAllDownload] = useState([]);
    const [viewData, setViewData] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [firstLoading, setFirstLoading] = useState(false);
    const [firstPPLoading, setFirstPPLoading] = useState(false);
    const [firstPLoading, setFirstPLoading] = useState(false);
    const defaultStartDate = moment().startOf('month');
    const defaultEndDate = moment().endOf('month');
    const [selectedCourierIds, setSelectedCourierIds] = useState([]);
    const [selectedMerchantIds, setSelectedMerchantIds] = useState([]);
    const defaultDateRange = [defaultStartDate.toDate(), defaultEndDate.toDate()];
    const [fStartDate, setFStartDate] = useState(defaultStartDate.format('YYYY-MM-DD'));
    const [fEndDate, setFEndDate] = useState(defaultEndDate.format('YYYY-MM-DD'));
    const [fDateRange, setFDateRange] = useState(defaultDateRange);
    const [openAlert, setOpenAlert] = useState(false);
    const [alertMesaage, setAlertMesaage] = useState('');
    const [severity, setSeverity] = useState('');
    const navigate = useNavigate();

    const handleAddModal = () => {
        setAddModal(true);
    };

    const handleCloseModal = () => {
        setAddModal(false);
    };

    const onLoadApi = () => {
        setFDateRange(defaultDateRange);
        setSelectedCourierIds([]);
        setSelectedMerchantIds([]);
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq = { merchant_id: user?.id, start_date: defaultStartDate.format('YYYY-MM-DD'), end_date: defaultEndDate.format('YYYY-MM-DD') }
        } else {
            postReq = { start_date: defaultStartDate.format('YYYY-MM-DD'), end_date: defaultEndDate.format('YYYY-MM-DD') }
        }
        setFirstLoading(false);
        commonApi.post('/admin/dashboard-b2b', postReq)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.data) {
                    // setAllDownload(response?.data?.data);
                    setAllData(response?.data?.data);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };
    const onPendingLoadApi = (pendingFilter) => {
        setAllPandingSummary([]);
        let postReq = { ...pendingFilter };
        if (user?.user_type === "Merchant") {
            postReq.merchant_id = user?.id
        } else {
            postReq.admin_id = user?.id
        }
        setFirstPLoading(false);
        commonApi.post('/admin/b2b-pending-summary', postReq)
            .then((response) => {
                setFirstPLoading(true);
                if (response?.data?.data) {
                    // setAllDownload(response?.data?.data);
                    setAllPandingSummary(response?.data?.data);
                }
            })
            .catch((error) => {
                setFirstPLoading(true);
                console.error('Error fetching data:', error);
            });
    };
    const onFilter = () => {
        setIsLoading(true);
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq = { merchant_id: user?.id, start_date: moment(fStartDate).format('YYYY-MM-DD'), end_date: moment(fEndDate).format('YYYY-MM-DD') }
        } else {
            postReq = { start_date: moment(fStartDate).format('YYYY-MM-DD'), end_date: moment(fEndDate).format('YYYY-MM-DD') }
        }
        if (selectedCourierIds.length > 0) {
            postReq.courier_id = selectedCourierIds
        }
        if (selectedMerchantIds.length > 0) {
            postReq.merchant_id = selectedMerchantIds
        }
        commonApi.post('/admin/dashboard-b2b', postReq)
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.data) {
                    // setAllDownload(response?.data?.data);
                    setAllData(response?.data?.data);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };
    const onPickupPendingLoadApi = (pickupPendingFilter) => {
        let postReq = { ...pickupPendingFilter };
        if (user?.user_type === "Merchant") {
            postReq.merchant_id = user?.id
        } else {
            postReq.admin_id = user?.id
        }
        setFirstPPLoading(false);
        commonApi.post('/admin/b2b-pickup-pending-summary', postReq)
            .then((response) => {
                setFirstPPLoading(true);
                if (response?.data?.data) {
                    // setAllDownload(response?.data?.data);
                    setAllPickupPandingSummary(response?.data?.data);
                }
            })
            .catch((error) => {
                setFirstPPLoading(true);
                console.error('Error fetching data:', error);
            });
    };

    const onPendingExport = (courierId = null, day = null) => {
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq.merchant_id = user?.id
        } else {
            postReq.admin_id = user?.id
        }
        if (courierId) {
            postReq.courier_id = courierId;
        }
        if (day > 0 && day <= 45) {
            const date = moment().subtract(day - 1, 'days').format('YYYY-MM-DD');
            postReq.date = date;
        }
        if (day === '45+') {
            const date = moment().subtract(45, 'days').format('YYYY-MM-DD');
            postReq.date = date;
            postReq.is_from = 1
        }
        setOpenAlert(false);
        setAlertMesaage('');
        setSeverity('');
        setIsLoading(true);
        commonApi.post('/admin/b2b-pending-summary/export', postReq)
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMesaage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMesaage(response?.data?.msg);
                    setSeverity('success');
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setAlertMesaage(error?.response?.data?.msg || error?.message || 'Error fetching data');
                setSeverity('error');
                setOpenAlert(true);
                console.error('Error fetching data:', error);
            });
    };
    const onPickupPendingExport = (merchatId = null, courierId = null, day = null) => {
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq.merchant_id = user?.id
        } else {
            postReq.admin_id = user?.id
        }
        if (merchatId) {
            postReq.merchant_id = merchatId;
        }
        if (courierId) {
            postReq.courier_id = courierId;
        }
        if (day > 0 && day <= 45) {
            const date = moment().subtract(day - 1, 'days').format('YYYY-MM-DD');
            postReq.date = date;
        }
        if (day === '10+') {
            const date = moment().subtract(10, 'days').format('YYYY-MM-DD');
            postReq.date = date;
            postReq.is_from = 1
        }
        setOpenAlert(false);
        setAlertMesaage('');
        setSeverity('');
        setIsLoading(true);
        commonApi.post('/admin/b2b-pickup-pending-summary/export', postReq)
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMesaage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMesaage(response?.data?.msg);
                    setSeverity('success');
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setAlertMesaage(error?.response?.data?.msg || error?.message || 'Error fetching data');
                setSeverity('error');
                setOpenAlert(true);
                console.error('Error fetching data:', error);
            });
    };
    useEffect(() => {
        onLoadApi();
    }, []);

    // You can provide any values or functions you want to make available to consumers here
    const contextValue = {
        selectedCourierIds,
        selectedMerchantIds,
        setSelectedCourierIds,
        setSelectedMerchantIds,
        severity,
        openAlert,
        alertMesaage,
        onPendingExport,
        onPickupPendingExport,
        firstPPLoading,
        onPickupPendingLoadApi,
        firstPLoading,
        onPendingLoadApi,
        allPickupPandingSummary,
        allPandingSummary,
        onFilter,
        fDateRange,
        fStartDate,
        fEndDate,
        onLoadApi,
        isLoading,
        firstLoading,
        viewData,
        allDownload,
        allData,
        handleAddModal,
        handleCloseModal,
        setAddModal,
        addModal,
        setAllData,
        setAllDownload,
        setViewData,
        setFirstLoading,
        setIsLoading,
        setFEndDate,
        setFStartDate,
        setFDateRange,
    };

    // Render the provider with children
    return <DashboardB2BContext.Provider value={contextValue}>{children}</DashboardB2BContext.Provider>;
}
